<template>
  <div class="m-page m-page-settle-in">
    <section class="settle-benefits" aria-labelledby="settle-benefits-title">
      <div class="settle-benefits-head">
        <div class="settle-benefits-copy">
          <h1 id="settle-benefits-title">加入化化平台的好处</h1>
          <p>创建属于自己的店铺<br>自主经营管理，海量订单等您接</p>
        </div>
        <img
          class="settle-benefits-figure"
          src="https://obs.huahuaeco.com/official/SettleInM/icon.png"
          alt="化化平台服务商入驻接单"
          loading="lazy"
        />
      </div>

      <div class="settle-card-list">
        <article v-for="item in benefitList" :key="item.title" class="settle-card">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </article>
      </div>
    </section>

    <section class="settle-section" aria-labelledby="settle-steps-title">
      <h2 id="settle-steps-title" class="settle-section-title">如何加入平台</h2>
      <ol class="settle-step-list" aria-label="化化平台入驻步骤">
        <li v-for="step in stepList" :key="step.no" class="settle-step-card">
          <div class="settle-step-main">
            <span class="settle-step-no">{{ step.no }}</span>
            <div>
              <h3>{{ step.title }}</h3>
              <p>{{ step.desc }}</p>
            </div>
          </div>
          <img
            v-if="step.qr"
            class="settle-step-qr"
            src="https://obs.huahuaeco.com/official/SettleIn/qrcode.png"
            alt="微信扫码入驻化化平台"
            loading="lazy"
          />
        </li>
      </ol>
    </section>

    <section class="settle-section" aria-labelledby="settle-faq-title">
      <h2 id="settle-faq-title" class="settle-section-title">入驻接单常见问题</h2>
      <div class="settle-faq-list">
        <article v-for="item in faqList" :key="item.question" class="settle-faq-card">
          <div class="settle-faq-question">
            <span aria-hidden="true">问</span>
            <h3>{{ item.question }}</h3>
          </div>
          <p v-for="line in item.answer" :key="line">{{ line }}</p>
        </article>
      </div>
    </section>

    <section class="settle-experience" aria-labelledby="settle-experience-title">
      <h2 id="settle-experience-title">立即体验</h2>
      <p>我们致力于服务至业主满意为止，不负每个客户的信任</p>
      <img src="https://obs.huahuaeco.com/official/SettleIn/qrcode.png" alt="化化平台服务商入驻二维码" loading="lazy" />
    </section>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../../utils/page-head'
import SeoStaticImages from '../../components/SeoStaticImages.vue'

export default {
  name: 'SettleInMobilePage',
  components: {
    SeoStaticImages
  },
  setup() {
    useHead(getPageHead('settleIn', 'https://www.huahuaeco.com/settlein'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/SettleInM/icon.png',
        'https://obs.huahuaeco.com/official/SettleIn/qrcode.png'
      ],
      benefitList: [
        {
          title: '平台交易，收款有保障',
          desc: '客户先托管订单资金到平台，客户验收通过后，平台将资金结算至服务方钱包'
        },
        {
          title: '多重守护，接单更放心',
          desc: '全过程证据留痕+平台全程见证，能更有效的减少纠纷，保障服务方权益'
        },
        {
          title: '积累业绩，赢得客户',
          desc: '每次用心完成交易，不仅能赢得客户好评与信赖，还能获得更多订单，赚取更多收入'
        },
        {
          title: '展现自己，打造品牌',
          desc: '通过真实内容创作+用心服务客户，全面展现自己，助力品牌打造与变现'
        }
      ],
      stepList: [
        { no: '01', title: '扫码注册', desc: '扫码打开小程序，选择“我是服务方”', qr: true },
        { no: '02', title: '填写信息', desc: '登记个人信息与技能信息' },
        { no: '03', title: '技能验证', desc: '学习平台规则，参与考试答题' },
        { no: '04', title: '开始接单', desc: '考试通过后，即可接单赚钱' }
      ],
      faqList: [
        {
          question: '如何加入化化平台?',
          answer: ['答：微信扫码打开“化化”小程序，选择“我是服务方”，按系统指引提交入驻资料、实名认证、学习与考试答题，通过即可接单。']
        },
        {
          question: '加入化化平台，需要什么条件?',
          answer: ['答：只要您是设计师、工人师傅（包含拆除、水电、泥瓦、木工、油漆等），具备装修设计或施工技能，能服务好客户，即可入驻平台。']
        },
        {
          question: '加入平台后，怎么接单?',
          answer: [
            '答：有两种方式：',
            '报价抢单：在接单大厅，找到客户需求，提交报名，与业主沟通后，提交报价方案，客户确认下单后，即接单成功。',
            '邀请接单：客户主动找您下单，您确认接单，即接单成功。'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.m-page {
  min-height: 100vh;
  padding-top: calc(88 * var(--rpx));
  padding-bottom: calc(44 * var(--rpx));
  background: #f4f7fb;
  overflow: hidden;
}

.settle-benefits,
.settle-section,
.settle-experience {
  padding: calc(44 * var(--rpx)) calc(32 * var(--rpx)) 0;
}

.settle-benefits-head {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: calc(220 * var(--rpx));
}

.settle-benefits-copy {
  position: relative;
  z-index: 1;
  width: calc(430 * var(--rpx));
  max-width: 66%;

  h1 {
    margin: 0;
    color: #262626;
    font-size: calc(36 * var(--rpx));
    font-weight: 700;
    line-height: 1.35;
  }

  p {
    margin: calc(20 * var(--rpx)) 0 0;
    color: #595959;
    font-size: calc(26 * var(--rpx));
    line-height: 1.58;
  }
}

.settle-benefits-figure {
  position: absolute;
  right: calc(-4 * var(--rpx));
  bottom: calc(-6 * var(--rpx));
  width: calc(250 * var(--rpx));
  height: auto;
  object-fit: contain;
}

.settle-card-list,
.settle-step-list,
.settle-faq-list {
  display: grid;
  gap: calc(32 * var(--rpx));
  margin: 0;
}

.settle-card {
  min-height: calc(160 * var(--rpx));
  padding: calc(32 * var(--rpx)) calc(40 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(20 * var(--rpx)) calc(40 * var(--rpx)) rgba(224, 229, 238, 0.2);

  h2 {
    margin: 0;
    color: #262626;
    font-size: calc(30 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }

  p {
    margin: calc(22 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(24 * var(--rpx));
    line-height: 1.68;
  }
}

.settle-section-title,
.settle-experience h2 {
  margin: 0 0 calc(56 * var(--rpx));
  color: #262626;
  font-size: calc(40 * var(--rpx));
  font-weight: 700;
  line-height: 1.35;
}

.settle-step-list {
  padding: 0;
  list-style: none;
}

.settle-step-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(24 * var(--rpx));
  min-height: calc(164 * var(--rpx));
  padding: calc(30 * var(--rpx)) calc(40 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(20 * var(--rpx)) calc(40 * var(--rpx)) rgba(224, 229, 238, 0.2);
}

.settle-step-main {
  display: flex;
  align-items: center;
  gap: calc(22 * var(--rpx));
  min-width: 0;

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(30 * var(--rpx));
    font-weight: 700;
    line-height: 1.35;
  }

  p {
    margin: calc(28 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(24 * var(--rpx));
    line-height: 1.55;
  }
}

.settle-step-no {
  flex: 0 0 calc(56 * var(--rpx));
  width: calc(56 * var(--rpx));
  height: calc(56 * var(--rpx));
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: calc(26 * var(--rpx));
  font-weight: 700;
  background: linear-gradient(180deg, #83ccff 0%, #4ca0ff 100%);
}

.settle-step-qr {
  flex: 0 0 calc(146 * var(--rpx));
  width: calc(146 * var(--rpx));
  height: calc(146 * var(--rpx));
  object-fit: contain;
}

.settle-faq-card {
  padding: calc(32 * var(--rpx)) calc(40 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(20 * var(--rpx)) calc(40 * var(--rpx)) rgba(224, 229, 238, 0.2);

  p {
    margin: calc(22 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(24 * var(--rpx));
    line-height: 1.7;
  }
}

.settle-faq-question {
  display: flex;
  align-items: center;
  gap: calc(16 * var(--rpx));

  span {
    flex: 0 0 calc(48 * var(--rpx));
    width: calc(48 * var(--rpx));
    height: calc(48 * var(--rpx));
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    font-size: calc(22 * var(--rpx));
    font-weight: 700;
    background: linear-gradient(180deg, #83ccff 0%, #4ca0ff 100%);
  }

  h3 {
    margin: 0;
    color: #262626;
    font-size: calc(30 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }
}

.settle-experience {
  text-align: center;

  h2 {
    margin-bottom: 0;
  }

  p {
    width: calc(620 * var(--rpx));
    max-width: 100%;
    margin: calc(24 * var(--rpx)) auto 0;
    color: #595959;
    font-size: calc(26 * var(--rpx));
    line-height: 1.65;
  }

  img {
    display: block;
    width: calc(300 * var(--rpx));
    height: calc(300 * var(--rpx));
    margin: calc(42 * var(--rpx)) auto 0;
    object-fit: contain;
  }
}

@media (min-width: 560px) {
  .settle-benefits,
  .settle-section,
  .settle-experience {
    padding-left: calc(56 * var(--rpx));
    padding-right: calc(56 * var(--rpx));
  }
}

@media (max-width: 360px) {
  .settle-benefits-copy {
    max-width: 68%;
  }

  .settle-benefits-figure {
    width: calc(220 * var(--rpx));
  }

  .settle-step-card {
    padding-left: calc(30 * var(--rpx));
    padding-right: calc(30 * var(--rpx));
  }
}
</style>
